import type { FieldCodec } from 'v5/core/entity-values/values.types';
import { customFieldColumns } from './customFieldColumns';
import { findCustomFieldRowForRead } from './customFieldRows';
import { formatStoredDate, parseStoredDate } from './storedDate';
import { validateField, validation } from './validation';

function isEmpty(value: Date | null): boolean {
  return value === null;
}

/**
 * DATE custom field. The API delivers `date_value` as an ISO string even
 * though the model types it as `Date`; both shapes are accepted on decode.
 */
export const dateCodec: FieldCodec<'date'> = {
  decode(entity, spec, ctx) {
    const row = findCustomFieldRowForRead(entity, spec.definition.id, ctx);
    const raw: Date | string | null = row?.date_value ?? null;
    if (raw === null) return null;
    return parseStoredDate(raw);
  },
  encode(value) {
    return {
      type: 'custom',
      columns: customFieldColumns({
        date_value: value === null ? null : formatStoredDate(value)
      })
    };
  },
  empty() {
    return null;
  },
  isEmpty,
  validate(value, spec) {
    return validateField(value, spec, isEmpty, value =>
      value !== null && Number.isNaN(value.getTime())
        ? validation.invalid({ code: 'invalid-date' })
        : validation.valid()
    );
  }
};
